import { render, staticRenderFns } from "./DetalhesResumoConsolidado.vue?vue&type=template&id=a4412f6c&scoped=true"
import script from "./DetalhesResumoConsolidado.vue?vue&type=script&lang=js"
export * from "./DetalhesResumoConsolidado.vue?vue&type=script&lang=js"
import style0 from "./DetalhesResumoConsolidado.vue?vue&type=style&index=0&id=a4412f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4412f6c",
  null
  
)

export default component.exports